import { TvGuideDictionary } from "core/tv-guide.context";
import { PopupContents } from "core/types";

type RemindButtonProps = {
    popupContents: PopupContents,
    dictionary: TvGuideDictionary,
    analytics: any,
    url: string
}

const RemindButton = (props: RemindButtonProps) => {
    const { popupContents, dictionary, analytics, url } = props;

    if (popupContents.link.current || popupContents.link.hide) {
        return null;
    }

    // const onClick = () => console.log("REMIND ME", popupContents.link.reminder);

    return (<a
        type="button"
        className="button programme-btn m-1"
        href={url}
        {...analytics}
    // onClick={onClick}
    >
        <span className="icon-set-reminder"></span>
        <span className="text">
            {dictionary.remindMe}
        </span>
    </a>);
}

export default RemindButton;